import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../auth/authentication-service';
import { environment } from 'src/environments/environment';

export abstract class BaseApiService {
    protected apiUrl = environment.apiUrl;
    protected apiUrlLocalReg = 'https://localhost:7095';

    constructor(protected http: HttpClient, private authService: AuthenticationService) { }

    protected getHttpOptions() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-client-app': 'mib-ui',//for tracing
                'Authorization': `Bearer ` + this.authService.getToken()
            }),
            withCredentials: true
        };
    }

    protected getHttpFileOptions() {
        return {
            headers: new HttpHeaders({
                'Authorization': `Bearer ` + this.authService.getToken(),
                'x-client-app': 'mib-ui'//for tracing
            }),
            withCredentials: true
        };
    }

    protected log(message: string) {
        console.log(`ApiService: ${message}`);
    }

    /**
   * Handle Http operation that failed.
   * Let the app continue.
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
    protected handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
